import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ButtonChipStyled} from './ButtonChipStyled';

const ButtonChip = ({ Question, OptionList, customClass, setButtonChipData, eveId, disabled }) => {
  const [selectedTag, setSelectedTag] = useState(null);

  const handleBadgeClick = (tag) => {
    if (selectedTag === tag) {
      setSelectedTag(null);
      setButtonChipData(null);
    } else {
      setSelectedTag(tag);
      const newData = {
        questionId: Question?.questionId,
        answer: tag,
        eventId: eveId,
      };
      setButtonChipData(newData);
    }
  };

  const isTagSelected = (tag) => selectedTag === tag;

  return (
    <ButtonChipStyled className={customClass}>
      <div className='npsQuestion'>{Question?.questionTitle}</div>
        <div>
            {OptionList.map((tag) => (
              <Button
                key={tag?.optionName}
                variant={isTagSelected(tag?.optionName) ? 'outline-primary' : 'outline-secondary'}
                className={`npsButton 
                ${isTagSelected(tag?.optionName) ? 'btnSelected' : ''} ${disabled ? 'disable' : ''}`}
                onClick={() => handleBadgeClick(tag?.optionName)}
              >
                {tag?.optionName}
              </Button>
            ))}
        </div>
    </ButtonChipStyled>
  );
};

ButtonChip.defaultProps = {
    Question: '',
    OptionList: [],
    customClass: '',
    eveId: '',
    setButtonChipData: ()=>{},
    disabled: false,
};

ButtonChip.propTypes = {
    Question: PropTypes.string,
    OptionList: PropTypes.array,
    customClass: PropTypes.string,
    setButtonChipData: PropTypes.func,
    eveId: PropTypes.string,
    disabled: PropTypes.bool,
};

export default ButtonChip;
